<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="termSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    placeholder="请选择合同条款"/>
</template>

<script>
/**
 * @Description: 合同条款查询组件
 * @Author: 菩萨蛮
 * @Date: 2020/9/3 11:06 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import AutoComplete from '../../../mixins/common/AutoComplete';

export default {
  name: 'TermAutoComplete',
  mixins: [AutoComplete],
  data() {
    return {
      url: '/sales/term?status=1&name=',
      itemName: 'name'
    };
  }
};
</script>

<style lang="scss" scoped>

.el-autocomplete {

}
</style>
